import React from "react";
import {Table} from "antd";
import {ColumnsType} from "antd/lib/table";
import {_t} from "../../../Common/components/InjectIntlContext";
import {useMultiples} from "../../apiHooks";
import {Link} from "react-router-dom";
import {NoData} from "../../../Common/components/NoData";

const columns = (_t: any): ColumnsType<any> => [
  {
    title: _t("Login"),
    dataIndex: "login",
    key: "login",
    render: (val, r) => <Link to={"/users/profile/" + r.user_id}>{val}</Link>,
  },
  {
    title: _t("IP"),
    dataIndex: "ip",
    key: "ip",
  },
];

const useTableData = (id) => {
  const {isLoading, data} = useMultiples({
    user_id: id,
  });
  return {isLoading, data};
};

export function MultiplesWidget({user}) {
  const {data, isLoading} = useTableData(user?.id);
  const translatedColumns = columns(_t);
  return (
    <>
      <Table
        loading={isLoading}
        columns={translatedColumns}
        rowKey="date"
        dataSource={data?.data}
        pagination={false}
        locale={{ emptyText: <NoData /> }}
      />
      <br/>
    </>
  );
}
